var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1969_8530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49954 1V6.5M10.9995 4.9V2.6C10.9995 2.03995 10.9995 1.75992 10.8905 1.54601C10.7947 1.35785 10.6417 1.20487 10.4535 1.10899C10.2396 1 9.95959 1 9.39954 1H4.05854C3.3278 1 2.96243 1 2.66733 1.13372C2.40724 1.25157 2.18619 1.44121 2.03016 1.68036C1.85312 1.9517 1.79757 2.31282 1.68645 3.03506L1.42491 4.73506C1.27836 5.68766 1.20508 6.16395 1.34644 6.53456C1.47051 6.85985 1.70386 7.13185 2.0065 7.30393C2.3513 7.5 2.8332 7.5 3.79701 7.5H4.19954C4.47956 7.5 4.61958 7.5 4.72653 7.5545C4.82061 7.60243 4.8971 7.67892 4.94504 7.773C4.99954 7.87996 4.99954 8.01997 4.99954 8.3V9.76708C4.99954 10.448 5.55154 11 6.23246 11C6.39487 11 6.54205 10.9044 6.60801 10.7559L8.28839 6.97509C8.36482 6.80312 8.40303 6.71714 8.46344 6.65409C8.51683 6.59836 8.5824 6.55575 8.65501 6.52959C8.73716 6.5 8.83125 6.5 9.01944 6.5H9.39954C9.95959 6.5 10.2396 6.5 10.4535 6.39101C10.6417 6.29513 10.7947 6.14215 10.8905 5.95399C10.9995 5.74008 10.9995 5.46005 10.9995 4.9Z",
    stroke: "#414651",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1969_8530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.1e41d07a8bf594f7436de5945ba87ab6.svg";
export { ForwardRef as ReactComponent };